/* eslint-disable react/destructuring-assignment */
import { CSSProperties, useEffect } from 'react';
import { Widget } from '@stockbit/ui';
import { useDispatch, useSelector } from 'react-redux';
import { format, parse } from 'date-fns';

import { alertLogSelector, effects, selectors } from './slice';
import { Td, Th, EmptyPriceAlert, TableLog } from './styled';

import { parseCountAbbrv2 } from 'utils/general';
import { convertToDate } from 'utils/date';

const { Table } = Widget;

const desc = {
  0: 'init',
  1: 'queue',
  2: 'loaded',
  3: 'reload',
  4: 'complete',
  5: 'cancel',
  6: 'error',
};
const mth = {
  gt: '>',
  lt: '<',
  gte: '>=',
  lte: '<=',
  eq: '=',
};

interface AlertLogContentProps {
  handleAddPriceAlert: (p1?: any, p2?: any, p3?: any) => void;
  maxHeight?: CSSProperties['maxHeight'];
}

function AlertLogContent({
  handleAddPriceAlert,
  maxHeight,
}: AlertLogContentProps) {
  const dispatch = useDispatch();
  const state = useSelector(alertLogSelector);

  const { data } = state;

  useEffect(() => {
    dispatch(effects.getAlertLog());
  }, [dispatch]);

  const columns = [
    {
      title: <Th>Symbol</Th>,
      dataIndex: 'symbol',
      key: 'symbol',
    },
    {
      title: <Th align="right">Condition</Th>,
      dataIndex: 'command',
      key: 'command',
      render: (v) => (
        <Td align="right">
          {`${mth[v.operator] || v.operator} ${parseCountAbbrv2(v.value, 0)}`}
        </Td>
      ),
    },
    {
      title: (
        <Th align="right" style={{ paddingRight: 0 }}>
          Triggered On
        </Th>
      ),
      dataIndex: 'updated',
      key: 'updated',
      sorter: (a, b) => {
        const dateA = new Date(a.updated_at).getTime();
        const dateB = new Date(b.updated_at).getTime();

        return dateA - dateB;
      },
    },
  ];

  // price alert data is empty
  if (data.length === 0) {
    return (
      <EmptyPriceAlert maxHeight={maxHeight}>
        <div className="empty-price-alert">
          <span>No log alert found</span>
        </div>
      </EmptyPriceAlert>
    );
  }

  const dataSource = data.map((dataAlertLog) => {
    if (dataAlertLog.command.stock) {
      const newData = { ...dataAlertLog };
      const symbolShow = newData.command.symbol_2
        ? newData.command.symbol_2.toUpperCase()
        : newData.command.stock.toUpperCase();
      newData.key = newData.alert_id;
      newData.symbol = <Td>{symbolShow}</Td>;
      newData.status = (
        <Td align="right">{desc[parseInt(dataAlertLog.status, 10)]}</Td>
      );
      newData.updated_at = newData.updated;
      const date = format(convertToDate(newData.updated), 'd MMM yyyy HH:mm');
      newData.updated = <Td align="right">{date}</Td>;

      return newData;
    }
    return dataAlertLog;
  });

  return (
    <div style={{ height: '100%', paddingBottom: '30px' }}>
      <TableLog
        style={{ height: 'calc(100% - 30px)', overflowY: 'auto' }}
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        onRow={(record) => ({
          onClick: (e) => handleAddPriceAlert(e, record, true),
        })}
        sortDirections={['ascend', 'descend', 'ascend']}
      />
    </div>
  );
}

AlertLogContent.defaultProps = {
  handleAddPriceAlert: () => {},
};

export default AlertLogContent;
